var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4694 9.29167C9.4694 8.96375 9.20357 8.69792 8.87565 8.69792H4.12565C3.79773 8.69792 3.5319 8.96375 3.5319 9.29167C3.5319 9.61959 3.79773 9.88542 4.12565 9.88542H8.87565C9.20357 9.88542 9.4694 9.61959 9.4694 9.29167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4694 12.4583C9.4694 12.1304 9.20357 11.8646 8.87565 11.8646H4.12565C3.79773 11.8646 3.5319 12.1304 3.5319 12.4583C3.5319 12.7863 3.79773 13.0521 4.12565 13.0521H8.87565C9.20357 13.0521 9.4694 12.7863 9.4694 12.4583Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.54232 0.78125C1.33995 0.78125 0.365234 1.75596 0.365234 2.95833V14.0417C0.365234 15.244 1.33995 16.2188 2.54232 16.2188H10.459C11.6614 16.2188 12.6361 15.244 12.6361 14.0417V5.30773C12.6361 5.00629 12.5378 4.71307 12.356 4.47255L9.98278 1.33149C9.72095 0.984944 9.31175 0.78125 8.87741 0.78125H2.54232ZM1.55273 2.95833C1.55273 2.4118 1.99579 1.96875 2.54232 1.96875H8.2819V5.44974C8.2819 5.77766 8.54773 6.04349 8.87565 6.04349H11.4486V14.0417C11.4486 14.5882 11.0055 15.0312 10.459 15.0312H2.54232C1.99579 15.0312 1.55273 14.5882 1.55273 14.0417V2.95833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfManagement);
export default __webpack_public_path__ + "static/media/selfManagement.75460fa9e4afe69acf969576513149f3.svg";
export { ForwardRef as ReactComponent };